import './root.scss';
import { connect } from 'react-redux';
import { loadNode } from './../state/root-actions';
import RootView from './root-view';
import * as InitialState from './../../initial-app-state/state/initial-app-state-actions';
import { resizeTree } from './../state/root-actions';

function mapStateToProps(state) {
  return {
    isMobilePhone: state.initialStateReducer.isMobilePhone,
    isTablet: state.initialStateReducer.isTablet,
    treeDividerX: state.rootReducer.treeDividerX,
    gridDividerX: state.rootReducer.gridDividerX,
    imagesDividerY: state.rootReducer.imagesDividerY,
    treeData: state.rootReducer.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    nodeChanged: idPlant => dispatch(loadNode(parseInt(idPlant))),
    changeIsMobilePhone: value => dispatch(InitialState.changeIsMobilePhone(value)),
    changeIsTablet: value => dispatch(InitialState.changeIsTablet(value)),
    resizeTree: x => dispatch(resizeTree(x))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RootView);



/** WEBPACK FOOTER **
 ** app/components/root/view/root-container.js
 **/